import { useRouterStore } from "@stores";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../css/generic.css";

const DashboardGenericComponent = () => {
  const modules = useRouterStore((state) => state.modules);
  const navigate = useNavigate();
  const [greeting, setGreeting] = useState("");
  const [time, setTime] = useState(new Date());

  // Saludo según hora del día
  useEffect(() => {
    const hour = new Date().getHours();
    if (hour >= 5 && hour < 12) setGreeting("Buenos días");
    else if (hour >= 12 && hour < 18) setGreeting("Buenas tardes");
    else setGreeting("Buenas noches");
  }, []);

  // Reloj en tiempo real
  useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  const formatTime = (date: Date) =>
    date.toLocaleTimeString("es-EC", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });

  const formatDate = (date: Date) =>
    date.toLocaleDateString("es-EC", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });

  // Capitalizar primera letra
  const capitalize = (str: string) =>
    str.charAt(0).toUpperCase() + str.slice(1);

  return (
    <div className="gdb-page">
      {/* ── Bienvenida ── */}
      <div className="gdb-welcome-card">
        <div className="gdb-welcome-left">
          <div className="gdb-greeting">{greeting} 👋</div>
          <div className="gdb-welcome-title">Bienvenido a ON-AIR</div>
          <div className="gdb-welcome-sub">
            Selecciona un módulo del menú lateral para comenzar a trabajar.
          </div>
        </div>
        <div className="gdb-clock-box">
          <div className="gdb-clock-time">{formatTime(time)}</div>
          <div className="gdb-clock-date">{capitalize(formatDate(time))}</div>
        </div>
      </div>

      {/* ── Módulos asignados ── */}
      {modules.length > 0 && (
        <div className="gdb-modules-section">
          <p className="gdb-section-label">Módulos disponibles</p>
          <div className="gdb-modules-grid">
            {modules.map((mod) => (
              <div
                key={mod.to}
                className="gdb-module-card"
                onClick={() => navigate(mod.to)}
              >
                <div className="gdb-module-icon-wrap">
                  {/* Inicial del módulo como ícono fallback */}
                  <span className="gdb-module-initial">
                    {mod.nameSort?.charAt(0)?.toUpperCase() ?? "M"}
                  </span>
                </div>
                <span className="gdb-module-name">{mod.nameSort}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ── Sin módulos ── */}
      {modules.length === 0 && (
        <div className="gdb-empty">
          <div className="gdb-empty-icon">🔒</div>
          <div className="gdb-empty-title">Sin módulos asignados</div>
          <div className="gdb-empty-sub">
            Contacta a tu administrador para que te asigne los permisos
            correspondientes.
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardGenericComponent;
